






















import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class MapButton extends Vue {
  @Prop({ default: '' })
  icon: string

  @Prop({ default: null })
  label: string | null

  @Prop({ type: Boolean, default: false })
  enabled: boolean
}
